module.exports = __webpack_public_path__ + "239857cafadaf65e9a26030eaedc5066.svg";